import { Component, OnInit, TemplateRef } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as moment from "moment";
import * as _ from "lodash";
import { DomSanitizer } from '@angular/platform-browser';
import { ModalViewreseauDeSoinDetailComponent } from "src/app/shared/components/modal-view-reseau-soin-detail/modal-view-reseau-soin-detail.component";

@Component({
  selector: 'app-modal-add-souscripteur',
  templateUrl: './modal-add-souscripteur.component.html',
  styleUrls: ['./modal-add-souscripteur.component.scss']
})
export class ModalAddSouscripteurComponent implements OnInit {

  modalRef: BsModalRef;
  listItems: Array<any> = [];
  items: Array<any> = [];
  itemToSave: any = {};
  filiale_id:any
  uniteFonctionnelleSelected: any = {};
  user: any = {};
  itemToSearch: any = {};
  currentPage: number = 0;
  itemsPerPage: number = 10;
  totalItems: number;
  show_password_field = true
  busyGet: Subscription;
  busySave: Subscription;
  loading: boolean = false;
  endPoint: string = "souscripteur";
  title:string='souscripteur'
  createMessage = ''
  editMessage =''
  deleteMessage =''
  itemsParentFonctionnalites=[]

  gender='F'
  itemsRole: any;
  itemsSpecialite: any=[];
  itemsCivilite:any=[]
  itemsGenre:any=[]
  itemsFiliale:any=[]
  searchKey:any
  dateNais: any;
  bsValue: Date;
  imageName: string;
  imageDisplay: any;
  currentItemImage: {
    fileBase64: any;
    fileName: any;
    extension: any;
    typeDocument: string;
  };
  selectedUniteFoncId: any;
  selectedSpecialiteId: any;
  listSelectedUniteFonctionnelle = [];
  isAutoPassword=false
  maxDate = new Date(
    new Date().getFullYear() - 18,
    new Date().getMonth() - 1,
    new Date().getDay()
  );
  minDate = new Date();
  itemsFucntParent: any[];
  itemsVille: any[]=[];
  itemsTypeSouscripteur: any;
  itemsModeProrata: any[];
  currentData: any;
  isDetailMode: any;
  itemsListeModeGestAccessoire:any=[{value:'GRILLE',libelle:'GRILLE'},{value:'PARTAGE',libelle:'PARTAGE'}]
  itemsTypeTarif: any[];
  itemsTarif: any;
  itemsReseauDeSoin: any;
  itemsTypeRemboursement: any;
  is_tpg: boolean;
  constructor(
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService: BsModalService,
    private utilities: UtilitiesService,
    private sanitizer: DomSanitizer,
    public bsModalRef: BsModalRef,
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser()
    // console.info('user-->: ',this.user)
    this.filiale_id = this.user.filiale_id
    let text1 = this.gender=='M'?'un':'une'
    this.createMessage = 'Vous êtes sur le point de créer '+text1+' '+this.title
    this.editMessage = 'Vous êtes sur le point de modifier '+text1+' '+this.title
    this.deleteMessage = 'Vous êtes sur le point de supprimer '+text1+' '+this.title

    setTimeout(() => {
      console.log('here');
      this.itemToSave.date_effet = new Date()
      this.itemToSave.date_echeance = new Date((new Date()).getFullYear(), 11, 31, 23, 59, 59, 999);
      if (this.currentData) {
        console.log('currentData: ',this.currentData)
        this.itemToSave = Object.assign({}, this.currentData);
        this.isDetailMode=this.currentData.isDetailMode
        
        // this.itemToSave.date_effet = this.itemToSave.date_effet?moment(this.itemToSave.date_effet).toDate():new Date()
        // this.itemToSave.date_echeance = this.itemToSave.date_echeance?moment(this.itemToSave.date_echeance).toDate():new Date((new Date()).getFullYear(), 11, 31, 23, 59, 59, 999)
        // this.itemToSave.date_effet = this.itemToSave.date_effet?moment(this.itemToSave.date_effet).format('MMMM Do YYYY, h:mm:ss a'):new Date()
        // this.itemToSave.date_echeance = this.itemToSave.date_echeance?moment(this.itemToSave.date_echeance).format('MMMM Do YYYY, h:mm:ss a'):new Date((new Date()).getFullYear(), 11, 31, 23, 59, 59, 999)
      }
    }, 50);


  }


  resetForm() {
    this.itemToSave.typeActeId = null;
    this.itemToSave.libelle = "";
  }

  onSelectTypeRemboursement(){
    let selected_type_remboursement = this.itemsTypeRemboursement.find(itr=>itr.id == this.itemToSave.type_remboursement_id)
    this.is_tpg = selected_type_remboursement && selected_type_remboursement.codification == 'TPG'
    if(!this.itemToSave.taux_tpg){
      this.itemToSave.taux_tpg = 100
    }
    if(!this.itemToSave.plafond_tpg){
      this.itemToSave.plafond_tpg = 0
    }
    if(!this.itemToSave.majoration_tpg){
      this.itemToSave.majoration_tpg = 0
    }
  }

  onSetTauxTpg(){
    if(this.itemToSave.taux_tpg>0){
      this.itemToSave.majoration_tpg=0
    }
    else{
      this.itemToSave.taux_tpg=100
    }
  }
  onSetMajorationTpg(){
    if(this.itemToSave.majoration_tpg>0){
      this.itemToSave.taux_tpg=0
    }
    else{
      this.itemToSave.taux_tpg=100

    }
  }
  

  getItemsTypeRemboursement() {
      let request = {
        user_id: this.user.id,
        filiale_id:this.user.filiale_id,
        index: 0,
        size: 1000,
        data: {},
      };
  
      this.busyGet = this.restClient
        .post("typeRemboursement/getByCriteria", request)
        .subscribe(
          (res) => {
            if (res && res["items"]) {
              this.itemsTypeRemboursement = _.orderBy(
                res["items"],
                ["libelle"],
                ["asc"]
              );
              if(this.itemToSave.id){
                this.onSelectTypeRemboursement()
              }
            } else {
              this.itemsTypeRemboursement = [];
            }
          },
          (err) => { 
            this.itemsTypeRemboursement = [];
  
          }
        );
    }

  confirmSaveItem(item) {
    console.info('item: ', item)

    console.info(" itemToSave ", this.itemToSave);
    console.info(" item ", item);


    if(!item.id && !item.code)
      item.code = this.generateUniqueString()

      // if (!item || !item.codification) {
      //   this.utilities.showNotification(
      //     "snackbar-danger",
      //     "Veuillez renseigner codification !",
      //     "bottom",
      //     "center"
      //   );
      //   return;
      // }
    // item.specialiteId = this.selectedSpecialite.id
    if(this.itemToSave.type_souscripteur_code == 'INDIV'){
      item.libelle = ''
      if (!item || !item.nom) {
        this.utilities.showNotification(
          "snackbar-danger",
          "Veuillez renseigner nom !",
          "bottom",
          "center"
        );
        return;
      }
  
      if (!item || !item.prenom) {
        this.utilities.showNotification(
          "snackbar-danger",
          "Veuillez renseigner prenom !",
          "bottom",
          "center"
        );
        return;
      }
    }
      // if (!item || !item.tarif_id) {
      //   this.utilities.showNotification(
      //     "snackbar-danger",
      //     "Veuillez renseigner tarif !",
      //     "bottom",
      //     "center"
      //   );
      //   return;
      // }

    // item.specialiteId = this.selectedSpecialite.id
    if(this.itemToSave.type_souscripteur_code == 'ENT'){
      item.nom = ''
      item.prenom = ''

      if (!item || !item.libelle) {
        this.utilities.showNotification(
          "snackbar-danger",
          "Veuillez renseigner libellé !",
          "bottom",
          "center"
        );
        return;
      }
  
      
    }

    // if (item.is_prorata_prime && !item.mode_prorata_id ) {
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez renseigner le mode de prorata!",
    //     "bottom",
    //     "center"
    //   );
    //   return;
    // }
    // if (!item.type_remboursement_id ) {
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez renseigner le type de remboursement!",
    //     "bottom",
    //     "center"
    //   );
    //   return;
    // }




    
 

    let objToSave = Object.assign({}, item);
    // objToSave.libelle = item.libelle.toUpperCase()

    Swal.fire({
      title: this.capitalize(this.title),
      text: objToSave?.id
        ? this.editMessage
        : this.createMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#0665aa",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
    }).then((result) => {
      if (result.value) {
        // ;
        this.saveItem(objToSave);
      }
    });
  }

  openModal(data: any, template: TemplateRef<any>) {
    
    let config = {
      backdrop: true,
      ignoreBackdropClick: true,
      id: 1,
      // class: "modal-lg",
      class: "gray modal-lg modal-width-60",
    };
    this.itemToSave = {};
    if (data) {
 
      this.itemToSave = Object.assign({}, data);
      this.onChangeTypeSouscripteur()
    }

    this.modalRef = this.modalService.show(template, config);
  }

  saveItem(item) {
    console.info("item to save", item);

    this.loading = true;

    let itemAEnregistrer = Object.assign({}, item);
    let reduce = [];
    if (this.currentItemImage && Object.keys(this.currentItemImage).length) {
      itemAEnregistrer.file_data = this.currentItemImage;
    } else {
      delete itemAEnregistrer.file_data;
    }
    console.log('currentItemImage: ',this.currentItemImage)



    var request = {
      user_id: this.user.id,
      // filiale_id:this.user.filiale_id,
      datas: [itemAEnregistrer],
    };

    this.busySave = this.restClient
      .post(
        this.endPoint + "" + (itemAEnregistrer.id ? "/update" : "/create"),
        request
      )
      .subscribe(
        (res) => {
          console.info("resul", res);
          this.loading = false;

          if (!res["hasError"]) {
              this.utilities.showNotification(
                "snackbar-success",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center"
              );
              this.bsModalRef.hide();
          } else {
            if (res["status"] && res["status"]["message"]) {
              this.utilities.showNotification(
                "snackbar-danger",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center"
              );
            }
          }
        },
        (err) => {
          this.utilities.showNotification(
            "snackbar-danger",
            this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center"
          );
          this.loading = false;
        }
      );
  }

  clearObject(obj) {
    return Object.keys(obj).reduce((acc, key) => {
      if (obj[key] !== null && obj[key] !== undefined) {
        acc[key] = obj[key];
      }
      return acc;
    }, {});
  }

  


  getItemsFiliale() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("filiale/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsFiliale", res);

          if (res && res["items"]) {
            this.itemsFiliale = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsFiliale = [];
          }
        },
        (err) => { }
      );
  }
  getItemsTypeSouscripteur() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      order_by:'libelle',
      data: {},
    };

    this.busyGet = this.restClient
      .post("typeSouscripteur/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsTypeSouscripteur", res);

          if (res && res["items"]) {
            this.itemsTypeSouscripteur = res["items"]
          } else {
            this.itemsTypeSouscripteur = [];
          }
        },
        (err) => { }
      );
  }

  getItemsVille() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("ville/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsVille", res);

          if (res && res["items"]) {
            this.itemsVille = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsVille = [];
          }
        },
        (err) => { }
      );
  }

  
  
  onSelectDate(event) {
    if (event) {
      (this.dateNais = moment(event).format("DD/MM/YYYY")),
        console.info("dateNais", this.dateNais);
    }
  }

  isValidEmail(email) {
    // Regular expression for validating email addresses
    var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
}

generateUniqueString() {
  // Get current timestamp in milliseconds
  var timestamp = new Date().getTime();

  // Generate a random number
  var randomNumber = Math.floor(Math.random() * 1000000); // Adjust range as needed

  // Concatenate timestamp and random number
  var uniqueString = timestamp.toString() + randomNumber.toString();

  return uniqueString;
}



capitalize(str) {
  return str.replace(/^\w/, (c) => c.toUpperCase());
}

load_filiale_data(){
    // this.getItemsFiliale();
}

uploadFile(event: any) {
  console.log('event: ',event)
  const reader = new FileReader();
  if (event.target.files && event.target.files.length) {
    const file = event.target.files[0];
    const fileName = file.name.split(".")[0];
    const Tabextension = file.name.split(".");
    const extension = Tabextension[Tabextension.length - 1];

    console.info("fileName", fileName);
    console.info("extension", extension);
    this.imageName = fileName + "." + extension;
    reader.onload = (readerEvent) => {
      const data = (readerEvent.target as any).result;
      this.imageDisplay = data;
      const fileBase64 = data.split(",")[1];
      this.currentItemImage = {
        fileBase64: fileBase64,
        fileName: fileName,
        extension: extension,
        typeDocument: "custom type",
      };
      // console.log('currentItemImage: ',this.currentItemImage)
    };
  }

  reader.readAsDataURL(event.target.files[0]);
}

onChangeTypeSouscripteur(){
  if(this.itemsTypeSouscripteur && this.itemsTypeSouscripteur.length)
    this.itemToSave.type_souscripteur_code = this.itemsTypeSouscripteur.filter(its=>its.id ==this.itemToSave.type_souscripteur_id )[0].codification
}

openModalPrestataireReseau() {
  if(!this.itemToSave.reseau_de_soin_id)
    return
  let modal: any;
  modal = ModalViewreseauDeSoinDetailComponent;
  this.modalRef = this.modalService.show(modal, {
    id: 5458545,
    class: "modal-width-75",
    ignoreBackdropClick: true,
    // data:boulangerie
  });
  let reseau_id = this.itemToSave.reseau_de_soin_id
  let reseau_de_soin_libelle = this.itemsReseauDeSoin.filter(ird=>ird.id == reseau_id)[0].libelle
  let data = {reseau_de_soin_id:reseau_id,reseau_de_soin_libelle:reseau_de_soin_libelle}
  if (data) this.modalRef.content.currentData = data;
  this.modalRef.onHide.subscribe((res) => {
  });


}

getItemsReseauDeSoin() {
  let request = {
    user_id: this.user.id,
    filiale_id:this.filiale_id || this.user.filiale_id,
    index: 0,
    size: 1000,
    data: {},
  };

  this.busyGet = this.restClient
    .post("reseauDeSoin/getByCriteria", request)
    .subscribe(
      (res) => {
        if (res && res["items"]) {
          this.itemsReseauDeSoin = _.orderBy(
            res["items"],
            ["libelle"],
            ["asc"]
          );
        } else {
          this.itemsReseauDeSoin = [];
        }
      },
      (err) => { 
        this.itemsReseauDeSoin = [];

      }
    );
}

getItemsModeProrata() {
  let request = {
    user_id: this.user.id,
    filiale_id:this.user.filiale_id,
    index: 0,
    size: 1000,
    data: {},
  };

  this.busyGet = this.restClient
    .post("modeProrata/getByCriteria", request)
    .subscribe(
      (res) => {
        if (res && res["items"]) {
          this.itemsModeProrata = _.orderBy(
            res["items"],
            ["libelle"],
            ["asc"]
          );
        } else {
          this.itemsModeProrata = [];
        }
      },
      (err) => { 
        this.itemsModeProrata = [];

      }
    );
}

getItemsTypeTarif() {
      let request = {
        user_id: this.user.id,
        filiale_id: this.user.filiale_id,
        index: 0,
        size: 1000,
        data: {
          // type_tarif_id:this.itemto
        },
      };
  
      this.busyGet = this.restClient
        .post("typeTarif/getByCriteria", request)
        .subscribe(
          (res) => {
            if (res && res["items"]) {
              this.itemsTypeTarif = _.orderBy(res["items"], ["libelle"], ["asc"]);
            } else {
              this.itemsTypeTarif = [];
            }
            this.getItemsTarif();
          },
          (err) => {
            this.itemsTypeTarif = [];
          }
        );
    }

    getItemsTarif() {
        let request = {
          user_id: this.user.id,
          filiale_id: this.user.filiale_id,
          index: 0,
          size: 1000,
          data: {
            type_tarif_id: this.itemsTypeTarif.find(
              (itt) => itt.codification == "TAR-SOUSC"
            ).id,
          },
        };
    
        this.busyGet = this.restClient
          .post("tarif/getByCriteria", request)
          .subscribe(
            (res) => {
              if (res && res["items"]) {
                this.itemsTarif = _.orderBy(res["items"], ["libelle"], ["asc"]);
              } else {
                this.itemsTarif = [];
              }
            },
            (err) => {
              this.itemsTarif = [];
            }
          );
      }

  ngOnInit() {
    this.resetForm();
    this.getItemsFiliale();
    this.getItemsTypeSouscripteur()
    this.getItemsModeProrata()
    this.getItemsVille()
    this.getItemsTypeTarif()
    this.getItemsReseauDeSoin()
    this.getItemsTypeRemboursement()
  }

}
